import Vue from "vue";
import VueI18n from "vue-i18n";

import de from "../locales/de.json";
import fr from "../locales/fr.json";
import it from "../locales/it.json";
import en from "../locales/en.json";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: "de",
  fallbackLocale: "de",
  messages: {
    de: de,
    fr: fr,
    it: it,
    en: en,
  },
});
